import LZString from 'lz-string';

export default {
    methods: {
        trimString(string, length) {
            return string && string.length > length ? `${string.substring(0, length)}...` : string;
        },
        compress(string) {
            return process.env.MIX_COMPRESS_LOCAL_STORAGE && process.env.MIX_COMPRESS_LOCAL_STORAGE === 'false' ? string : LZString.compress(string);
        },
        decompress(string) {
            return process.env.MIX_COMPRESS_LOCAL_STORAGE && process.env.MIX_COMPRESS_LOCAL_STORAGE === 'false' ? string : LZString.decompress(string);
        },
    },
};
